import { LogoutAccount } from "../../_api/Admin";
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { updateMail, updateDefaultPage } from "../../_api/User";
import { normalizeLoginPath } from "../../_helpers/resolveLoginLanding";
import toast from "react-hot-toast";
import doc from "../../../../assets/Documentation.pdf";
import reglementGrandesEaux2026 from "../../../../assets/Reglement_Grandes_Eaux_2026.pdf";

export const UserIcon = (props) => {
    const { setUser, user, currentApp } = props;
    const { pathname } = useLocation();
    const [isVisible, setIsVisible] = useState(false);
    const [biblioVisible, setBiblioVisible] = useState(false);
    const [isCoarsePointer, setIsCoarsePointer] = useState(false);

    const [isClicked, setIsClicked] = useState(user?.is_receiving_mail);

    const menuRef = useRef(null);
    const biblioRef = useRef(null);

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
            return;
        }

        const mql = window.matchMedia("(pointer: coarse)");
        const update = () => setIsCoarsePointer(Boolean(mql.matches));
        update();

        if (typeof mql.addEventListener === "function") {
            mql.addEventListener("change", update);
            return () => mql.removeEventListener("change", update);
        }
        // Safari / older browsers
        // eslint-disable-next-line deprecation/deprecation
        mql.addListener(update);
        // eslint-disable-next-line deprecation/deprecation
        return () => mql.removeListener(update);
    }, []);

    useEffect(() => {
        const onPointerDown = (e) => {
            const target = e.target;
            if (!(target instanceof Node)) {
                return;
            }

            const clickedUserMenu =
                menuRef.current instanceof Node && menuRef.current.contains(target);
            const clickedBiblioMenu =
                biblioRef.current instanceof Node && biblioRef.current.contains(target);

            if (!clickedUserMenu) {
                setIsVisible(false);
            }
            if (!clickedBiblioMenu) {
                setBiblioVisible(false);
            }
        };

        document.addEventListener("mousedown", onPointerDown);
        document.addEventListener("touchstart", onPointerDown, { passive: true });
        return () => {
            document.removeEventListener("mousedown", onPointerDown);
            document.removeEventListener("touchstart", onPointerDown);
        };
    }, []);

    const logout = (e) => {
        e.preventDefault();
        setUser(null);
        LogoutAccount()
            .then((resp) => {
                // Forcer un rechargement complet de la page pour éviter les problèmes de cache
                window.location.href = "/";
            })
            .catch((resp) => {
                console.log(resp);
                // Même en cas d'erreur, rediriger vers la page de login
                window.location.href = "/";
            });
    };

    const menus = [
        {
            title: "Se déconnecter",
            action: logout,
        },
    ];

    const menuBibliotheque = [
        {
            id: "DOCUMENTATION_HORDYEVENT",
            title: "Documentation HordyEvent",
            action: () => window.open(doc, "_blank"),
            alt: "Documentation.pdf",
        },
        {
            id: "REGLEMENT_GRANDES_EAUX_2026",
            title: "Réglement des Grandes Eaux 2026",
            action: () => window.open(reglementGrandesEaux2026, "_blank"),
            alt: "Reglement_Grandes_Eaux_2026.pdf",
        },
    ];

    return (
        <>
            <div className="flex items-center w-full justify-between">
                <div>
                    {/* spacer de gauche */}
                </div>
                {currentApp === "MANIFESTATION" &&
                    <>
                        <div className="relative top-0 mr-10 m-2 hidden md:block w-max bg-amber-100 text-amber-600 px-4 py-2 rounded-md text-sm z-10">
                            ⚠️ Si vous ne recevez pas d’email, vérifiez l’onglet « Mes participations »
                        </div>
                    </>
                }
                <div className="flex items-center justify-end h-full gap-2">
                    <div
                        className="cursor-pointer m-2"
                        title="Définir cette page comme page d’accueil"
                        onClick={() => {
                            const default_page = normalizeLoginPath(pathname);
                            if (!default_page) {
                                return;
                            }
                            updateDefaultPage({ default_page })
                                .then((resp) => {
                                    if (resp?.data) {
                                        toast(resp.data.message ?? "Enregistré.");
                                        setUser((prev) =>
                                            prev
                                                ? { ...prev, default_page: resp.data.default_page }
                                                : prev
                                        );
                                    }
                                })
                                .catch((error) => {
                                    console.error("Erreur default_page:", error);
                                });
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className={`w-6 h-6 ${normalizeLoginPath(pathname) ===
                                normalizeLoginPath(user?.default_page)
                                ? "text-amber-500"
                                : "text-gray-400"
                                } hover:text-gray-700`}
                            aria-hidden
                        >
                            <path
                                fillRule="evenodd"
                                d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                                clipRule="evenodd"
                            />
                        </svg>

                    </div>
                    <div
                        className="cursor-pointer m-2"
                        title={
                            isClicked
                                ? "Notification activée"
                                : "Notification désactivée"
                        }
                        onClick={() => {
                            updateMail({ isClicked: !isClicked })
                                .then((resp) => {
                                    if (resp && resp.data) {
                                        toast(resp.data.message);
                                        setIsClicked(resp.data.user);
                                    }
                                })
                                .catch((error) => {
                                    console.error("Erreur lors de la mise à jour des notifications:", error);
                                    // Ne pas changer l'état si la requête échoue
                                });
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`w-6 h-6 ${isClicked ? "text-red-500" : "text-gray-700"
                                } hover:text-black`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15 17h5l-1.405-1.405C17.202 14.63 17 13.842 17 13V10a5.002 5.002 0 00-4-4.9V5a2 2 0 10-4 0v.1A5.002 5.002 0 005 10v3c0 .842-.202 1.63-.595 2.595L3 17h5m4 0a3 3 0 01-6 0"
                            />
                        </svg>
                    </div>
                    {/* Bibliothèque */}
                    {currentApp === "MANIFESTATION" &&
                        <div
                            title="Bibliothèque"
                            ref={biblioRef}
                            onMouseEnter={() => !isCoarsePointer && setBiblioVisible(true)}
                            onMouseLeave={() => !isCoarsePointer && setBiblioVisible(false)}
                            className="h-full items-center justify-center relative"
                        >
                            <button
                                type="button"
                                className="h-full flex items-center justify-center"
                                aria-haspopup="menu"
                                aria-expanded={biblioVisible}
                                onClick={() => setBiblioVisible((v) => !v)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                                </svg>

                            </button>
                            {biblioVisible && (
                                // <div className="absolute z-10 mt-2 top-12 left-2 right-2 sm:left-auto sm:right-2 w-[calc(100vw-1rem)] sm:w-72 bg-white border rounded-sm shadow-sm">
                                <div className="absolute z-10 mt-2 top-12 -left-42 right-1 sm:left-auto w-64 sm:w-64 bg-white border rounded-sm shadow-sm">
                                    {menuBibliotheque.map((menu, idx) => {
                                        return (
                                            <button
                                                key={idx}
                                                title={menu.alt}
                                                type="button"
                                                onClick={() => {
                                                    setBiblioVisible(false);
                                                    menu.action();
                                                }}
                                                className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 cursor-pointer transition-all duration-200 text-left whitespace-nowrap"
                                            >
                                                {menu.title}
                                            </button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>}
                </div>
            </div >
            <div
                ref={menuRef}
                onMouseEnter={() => !isCoarsePointer && setIsVisible(true)}
                onMouseLeave={() => !isCoarsePointer && setIsVisible(false)}
                className="min-w-20 flex h-full relative"
            >
                <button
                    type="button"
                    aria-haspopup="menu"
                    aria-expanded={isVisible}
                    onClick={() => setIsVisible((v) => !v)}
                    className="flex text-nowrap mx-1 sm:mx-4 items-center justify-between w-full px-3 sm:px-4 py-3 text-sm font-medium text-gray-700 transition-all duration-200 rounded-lg hover:bg-gray-100"
                >
                    <span className="hidden sm:inline">
                        {(user.first_name ?? "") + " " + (user.last_name ?? "")}
                    </span>
                    <span className="inline-flex sm:hidden items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                        </svg>



                    </span>
                    <svg
                        className="w-5 h-5 ml-auto"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                        />
                    </svg>
                </button>
                {isVisible && (
                    <div className="absolute z-90 mt-2 top-12 -left-30 right-1 sm:left-auto w-48 sm:w-56 bg-white border rounded-sm shadow-sm">
                        {menus.map((menu, idx) => {
                            return (
                                <button
                                    key={idx}
                                    type="button"
                                    onClick={(e) => {
                                        setIsVisible(false);
                                        menu.action(e);
                                    }}
                                    className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 cursor-pointer transition-all duration-200 text-left"
                                >
                                    {menu.title}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </>
    );
};
